"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleChoiceOrCustom = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _useOurTranslation = require("../../utils/useOurTranslation");

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _CheckBox = _interopRequireDefault(require("@material-ui/icons/CheckBox"));

var _CheckBoxOutlineBlank = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));

var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));

var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));

var _TextField = _interopRequireDefault(require("@jobmatchme/ui/es/components/TextField"));

var _IntroText = _interopRequireDefault(require("../IntroText"));

var _FormFieldsBox = _interopRequireDefault(require("../FormFieldsBox"));

var _Optimizers = require("../../utils/Optimizers");

var _ProfileProvider = require("../../provider/ProfileProvider");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * MultipleChoice component for whitelabel registration funnel
 * @param {*} param0
 */
var SingleChoiceOrCustomComponent = function SingleChoiceOrCustomComponent(_ref) {
  var config = _ref.config,
      context = _ref.context;
  var t = (0, _useOurTranslation.useComponentTranslation)(config);

  var _useContext = (0, _react.useContext)(_ProfileProvider.ProfileActionsContext),
      setValue = _useContext.setValue;

  var handleChange = function handleChange(event) {
    var value = event.target.value;

    if (value !== config.customOption) {
      setValue(config.valueName, {
        choice: value,
        custom: null
      });
    } else {
      setValue(config.valueName, {
        choice: value
      });
    }
  };

  var handleCustomChange = function handleCustomChange(event) {
    if (context[config.valueName].value.choice === config.customOption) {
      setValue(config.valueName, {
        custom: event.target.value
      });
    }
  };

  var customDisabled = !(context[config.valueName].value.choice === config.customOption);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _styleModule.default.multipleChoice,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IntroText.default, {
      headline: t(config.translations.text),
      text: config.translations.hint ? t(config.translations.hint) : ''
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormFieldsBox.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RadioGroup.default, {
        "aria-label": t(config.translations.text),
        name: config.valueName,
        value: String(context[config.valueName].value.choice),
        onChange: handleChange,
        children: config.options && Object.entries(config.options).map(function (_ref2) {
          var _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
              option = _ref3[0],
              translation = _ref3[1];

          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: _styleModule.default.row,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormControlLabel.default, {
              value: option,
              className: _styleModule.default.formControlLabel,
              labelPlacement: "start",
              control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Radio.default, {
                className: _styleModule.default.radioBtn,
                style: {
                  padding: '9px !important'
                },
                icon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBoxOutlineBlank.default, {
                  className: _styleModule.default.sizeIconEmpty
                }),
                checkedIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckBox.default, {
                  className: _styleModule.default.sizeIconChecked,
                  color: "primary"
                })
              }),
              label: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: "".concat(_styleModule.default.label, " ").concat(context[config.valueName].value.choice === option ? _styleModule.default.bold : ''),
                children: t(translation)
              })
            })
          }, "".concat(config.valueName, "_").concat(option));
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: _styleModule.default.LongText,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextField.default, {
        className: customDisabled ? _styleModule.default.TextFieldDisabled : _styleModule.default.TextField,
        name: config.valueName,
        defaultValue: context[config.valueName].value.custom,
        onBlur: handleCustomChange,
        placeholder: t(config.translations.inputField),
        rows: 4,
        disabled: customDisabled,
        multiline: true,
        fullWidth: true,
        noBorder: true,
        defaultInput: true
      })
    })]
  });
};

var SingleChoiceOrCustomWrapper = (0, _Optimizers.memoizeComponentByValue)(SingleChoiceOrCustomComponent);

var SingleChoiceOrCustom = function SingleChoiceOrCustom(_ref4) {
  var config = _ref4.config;
  var context = (0, _react.useContext)(_ProfileProvider.ProfileContext);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SingleChoiceOrCustomWrapper, {
    config: config,
    context: context
  });
};

exports.SingleChoiceOrCustom = SingleChoiceOrCustom;